(function () {
  'use strict';

  var LEGACY_RANGES = {
    '10': { brand: 'Stone Island', line: 'Reissues / special projects', family: 'stone-island' },
    '13': { brand: 'C.P. Company', line: 'C.P. Company Undersixteen', family: 'cp-company' },
    '14': { brand: 'Stone Island', line: 'Stone Island Denims', family: 'stone-island' },
    '15': { brand: 'Stone Island', line: 'Stone Island mainline', family: 'stone-island' },
    '16': { brand: 'Stone Island', line: 'Stone Island Junior', family: 'stone-island' },
    '18': { brand: 'C.P. Company', line: 'C.P. Company', family: 'cp-company' },
    '19': { brand: 'Stone Island', line: 'Stone Island Shadow Project', family: 'stone-island' },
    '20': { brand: 'C.P. Company', line: 'C.P. Company Donna', family: 'cp-company' },
    '25': { brand: 'Stone Island', line: 'Stone Island Limited / special editions', family: 'stone-island' }
  };

  var LEGACY_TYPES = {
    '0': 'Leather garments',
    '1': 'Shirts & overshirts',
    '2': 'T-shirts & polos',
    '3': 'Trousers',
    '4': 'Jackets & outerwear',
    '5': 'Knitwear',
    '6': 'Sweatshirts & fleece',
    '7': 'Long coats & parkas',
    '8': 'Suits / tailored garments',
    '9': 'Accessories, bags & headwear',
    'A': 'Jacket / blazer',
    'G': 'Gilet / waistcoat',
    'L': 'Shorts',
    'M': 'Jacket / outerwear',
    'Q': 'Jacket / outerwear',
    'S': 'Footwear'
  };

  var CP_DIVISIONS = {
    'CM': 'C.P. Company menswear',
    'CK': 'C.P. Company kidswear',
    'CW': 'C.P. Company womenswear'
  };

  var CP_CATEGORIES = {
    'AC': 'Accessories',
    'KN': 'Knitwear',
    'OS': 'Overshirts',
    'OW': 'Outerwear',
    'PA': 'Trousers',
    'PL': 'Polo shirts',
    'SH': 'Shirts',
    'SP': 'Sweatpants',
    'SS': 'Sweatshirts & hoodies',
    'TS': 'T-shirts'
  };

  function normaliseInput(value) {
    var display = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/^ART(?:ICLE)?\.?\s*/i, '')
      .replace(/[‐‑‒–—−]/g, '-');

    return {
      display: display.replace(/\s+/g, ' '),
      compact: display.replace(/[^A-Z0-9]/g, '')
    };
  }

  function formatSeason(kind, year) {
    if (kind === 'ss') {
      return {
        short: 'S/S ' + year,
        long: 'Spring / Summer ' + year
      };
    }

    return {
      short: 'A/W ' + year,
      long: 'Autumn / Winter ' + year
    };
  }

  function legacySeason(code) {
    var number = Number(code);
    if (!Number.isInteger(number) || number < 12 || number > 81) return null;

    var year = 1990 + Math.floor((number - 12) / 2);
    return formatSeason(number % 2 === 0 ? 'ss' : 'aw', year);
  }

  function currentCpSeason(code) {
    var number = Number(code);
    if (!Number.isInteger(number) || number < 0 || number > 39) return null;

    var year = 2016 + Math.floor(number / 2);
    var season = formatSeason(number % 2 === 0 ? 'ss' : 'aw', year);
    season.provisional = number > 20;
    return season;
  }

  function newStoneSeason(prefix) {
    var match = String(prefix || '').match(/^([K-Z])([12])S$/);
    if (!match) return null;

    var year = 2025 + (match[1].charCodeAt(0) - 75);
    var season = formatSeason(match[2] === '1' ? 'ss' : 'aw', year);
    season.provisional = !/^(K1S|K2S|L1S|L2S)$/.test(prefix);
    return season;
  }

  function stripStoneColourSuffix(code) {
    return code.replace(/V[0-9A-Z]{4,6}$/, '');
  }

  function createBase(normalised) {
    return {
      valid: true,
      normalised: normalised.compact,
      displayCode: normalised.display || normalised.compact,
      brand: 'Unknown',
      family: 'unknown',
      season: 'Unknown season',
      seasonLong: 'The season could not be resolved safely.',
      line: 'Unknown range',
      category: 'Unknown category',
      format: 'Unrecognised format',
      confidence: 'Partial decode',
      parts: [],
      warnings: [],
      searchTerms: normalised.compact ? [normalised.compact] : []
    };
  }

  function decodeLegacyNumeric(normalised) {
    var code = normalised.compact;
    var match = code.match(/^(\d{2})(\d{2})([0-9A-Z])([0-9A-Z]{2,})(?:V[0-9A-Z]{4,6})?$/);
    if (!match) return null;

    var season = legacySeason(match[1]);
    var range = LEGACY_RANGES[match[2]];
    if (!season || !range) return null;

    var type = LEGACY_TYPES[match[3]];
    var result = createBase(normalised);
    var searchBase = stripStoneColourSuffix(code);

    result.brand = range.brand;
    result.family = range.family;
    result.season = season.short;
    result.seasonLong = season.long;
    result.line = range.line;
    result.category = type || 'Undocumented garment code';
    result.format = 'Legacy numeric ART';
    result.confidence = type ? 'Community-documented' : 'Partial decode';
    result.searchTerms = [searchBase];
    if (searchBase !== code) result.searchTerms.push(code);
    result.parts = [
      { label: 'Season code', code: match[1], meaning: season.long },
      { label: 'Range code', code: match[2], meaning: range.line },
      { label: 'Garment code', code: match[3], meaning: type || 'Not safely documented' },
      { label: 'Style reference', code: match[4], meaning: 'Model / material reference within the collection' }
    ];

    if (!type) {
      result.warnings.push('The season and range decode cleanly, but this garment-category character is not in the documented table.');
    }

    return result;
  }

  function decodeNewStone(normalised) {
    var code = normalised.compact;
    var match = code.match(/^([K-Z][12]S)(\d{2})([0-9A-Z])([0-9A-Z]{1,})$/);
    if (!match) return null;

    var season = newStoneSeason(match[1]);
    var range = LEGACY_RANGES[match[2]];
    if (!season || !range || range.family !== 'stone-island') return null;

    var type = LEGACY_TYPES[match[3]];
    var result = createBase(normalised);
    var searchBase = stripStoneColourSuffix(code);

    result.brand = 'Stone Island';
    result.family = 'stone-island';
    result.season = season.short;
    result.seasonLong = season.long;
    result.line = range.line;
    result.category = type || 'Undocumented garment code';
    result.format = 'New alphanumeric ART';
    result.confidence = season.provisional ? 'Provisional season' : (type ? 'Community-documented' : 'Partial decode');
    result.searchTerms = [searchBase];
    if (searchBase !== code) result.searchTerms.push(code);
    result.parts = [
      { label: 'Season prefix', code: match[1], meaning: season.long },
      { label: 'Range code', code: match[2], meaning: range.line },
      { label: 'Garment code', code: match[3], meaning: type || 'Not safely documented' },
      { label: 'Style reference', code: match[4], meaning: 'Modern model / material reference' }
    ];

    if (season.provisional) {
      result.warnings.push('This future prefix follows the documented K/L sequence, but has not yet been independently confirmed.');
    }
    if (!type) {
      result.warnings.push('The season and range decode cleanly, but this garment-category character is not in the documented table.');
    }

    return result;
  }

  function decodeCurrentCp(normalised) {
    var code = normalised.compact;
    var full = code.match(/^(RC|\d{2})(CM|CK|CW)([A-Z]{2})(\d{3}[A-Z]{1,2})(\d{6})?([A-Z])?(\d{3,4})?$/);
    var broad = full || code.match(/^(RC|\d{2})(CM|CK|CW)([A-Z]{2})([0-9A-Z]+)$/);
    if (!broad) return null;

    var seasonCode = broad[1];
    var divisionCode = broad[2];
    var categoryCode = broad[3];
    var season = seasonCode === 'RC' ? null : currentCpSeason(seasonCode);
    if (seasonCode !== 'RC' && !season) return null;

    var result = createBase(normalised);
    var division = CP_DIVISIONS[divisionCode] || 'Undocumented C.P. Company division';
    var category = CP_CATEGORIES[categoryCode];
    var model = full ? full[4] : broad[4];
    var styleBase = seasonCode + divisionCode + categoryCode + model;

    result.brand = 'C.P. Company';
    result.family = 'cp-company';
    result.season = seasonCode === 'RC' ? 'Carry-over / continuative' : season.short;
    result.seasonLong = seasonCode === 'RC' ? 'A continuative style without a single season assignment' : season.long;
    result.line = division;
    result.category = category || 'Undocumented category code';
    result.format = 'Current C.P. Company ART';
    result.confidence = season && season.provisional ? 'Provisional season' : (category ? 'Community-documented' : 'Partial decode');
    result.searchTerms = [styleBase];
    if (styleBase !== code) result.searchTerms.push(code);
    result.parts = [
      {
        label: seasonCode === 'RC' ? 'Collection code' : 'Season code',
        code: seasonCode,
        meaning: seasonCode === 'RC' ? 'Carry-over / continuative' : season.long
      },
      { label: 'Division', code: divisionCode, meaning: division },
      { label: 'Category', code: categoryCode, meaning: category || 'Not safely documented' },
      { label: 'Model', code: model, meaning: 'Style number within the collection' }
    ];

    if (full && full[5]) {
      result.parts.push({ label: 'Fabric code', code: full[5], meaning: 'Internal fabric reference shared across colourways' });
    }
    if (full && full[6]) {
      result.parts.push({ label: 'Treatment code', code: full[6], meaning: 'Internal dye / treatment character; value not publicly documented' });
    }
    if (full && full[7]) {
      result.parts.push({ label: 'Colour code', code: full[7], meaning: 'Colourway reference' });
    }

    if (season && season.provisional) {
      result.warnings.push('This season is projected from the current C.P. Company sequence and has not yet been independently confirmed.');
    }
    if (!category) {
      result.warnings.push('The season and division decode cleanly, but this two-letter category is not in the documented table.');
    }

    return result;
  }

  function decodeTransitionalCp(normalised) {
    var code = normalised.compact;
    var match = code.match(/^(\d{2})(S|W)CPU([0-9A-Z]+)$/);
    if (!match) return null;

    var yearNumber = Number(match[1]);
    if (yearNumber < 10 || yearNumber > 19) return null;

    var year = 2000 + yearNumber;
    var season = formatSeason(match[2] === 'S' ? 'ss' : 'aw', year);
    var result = createBase(normalised);

    result.brand = 'C.P. Company';
    result.family = 'cp-company';
    result.season = season.short;
    result.seasonLong = season.long;
    result.line = 'C.P. Company';
    result.category = 'Category not safely documented';
    result.format = 'Transitional C.P. Company style code';
    result.confidence = 'Partial decode';
    result.searchTerms = [code];
    result.parts = [
      { label: 'Year', code: match[1], meaning: String(year) },
      { label: 'Season letter', code: match[2], meaning: match[2] === 'S' ? 'Spring / Summer' : 'Autumn / Winter' },
      { label: 'Brand marker', code: 'CPU', meaning: 'C.P. Company' },
      { label: 'Style reference', code: match[3], meaning: 'Model / material reference' }
    ];
    result.warnings.push('This transitional format exposes the year and season, but its remaining internal category structure is not decoded here.');

    return result;
  }

  function decodeArtNumber(value) {
    var normalised = normaliseInput(value);
    if (!normalised.compact) {
      return { valid: false, message: 'Enter an ART or style number first.' };
    }

    if (/^CLG\d{10,14}$/.test(normalised.compact)) {
      return {
        valid: false,
        message: 'That looks like a Certilogo CLG code, not an ART number. Keep CLG codes private and use the official authentication service.'
      };
    }

    if (normalised.compact.length < 6) {
      return { valid: false, message: 'That code is too short to identify safely. Check the care label and try the complete ART number.' };
    }

    var result =
      decodeNewStone(normalised) ||
      decodeCurrentCp(normalised) ||
      decodeTransitionalCp(normalised) ||
      decodeLegacyNumeric(normalised);

    if (result) return result;

    var fallback = createBase(normalised);
    fallback.valid = true;
    fallback.brand = 'Format not recognised';
    fallback.season = 'No safe decode';
    fallback.seasonLong = 'This may be an early, special-project or incomplete reference.';
    fallback.line = 'Manual research needed';
    fallback.category = 'Unknown';
    fallback.format = 'Unsupported / incomplete ART';
    fallback.confidence = 'Archive search only';
    fallback.parts = [
      { label: 'Entered reference', code: normalised.compact, meaning: 'No documented structure matched safely' }
    ];
    fallback.warnings.push('The checker will still search the Dans Designer catalogue for this exact reference.');
    return fallback;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function unique(values) {
    return values.filter(function (value, index, array) {
      return value && array.indexOf(value) === index;
    });
  }

  function resultHtml(result) {
    var parts = result.parts.map(function (part) {
      return (
        '<div class="dd-art-checker__part">' +
          '<dt>' + escapeHtml(part.label) + '</dt>' +
          '<dd><span class="dd-art-checker__part-code">' + escapeHtml(part.code) + '</span>' + escapeHtml(part.meaning) + '</dd>' +
        '</div>'
      );
    }).join('');

    var warnings = result.warnings.map(function (warning) {
      return '<p class="dd-art-checker__result-warning">' + escapeHtml(warning) + '</p>';
    }).join('');

    return (
      '<article class="dd-art-checker__result-card">' +
        '<div class="dd-art-checker__result-top">' +
          '<div class="dd-art-checker__result-summary">' +
            '<div class="dd-art-checker__result-kicker">' +
              '<span class="dd-art-checker__brand-pill">' + escapeHtml(result.brand) + '</span>' +
              '<span class="dd-art-checker__confidence-pill">' + escapeHtml(result.confidence) + '</span>' +
            '</div>' +
            '<h2>' + escapeHtml(result.season) + '</h2>' +
            '<div class="dd-art-checker__result-code-row">' +
              '<span class="dd-art-checker__result-code">' + escapeHtml(result.normalised) + '</span>' +
              '<button class="dd-art-checker__result-copy" type="button" data-dd-art-copy>Copy link</button>' +
            '</div>' +
          '</div>' +
          '<div class="dd-art-checker__result-meta">' +
            '<div class="dd-art-checker__meta-item"><span>Range / division</span><strong>' + escapeHtml(result.line) + '</strong></div>' +
            '<div class="dd-art-checker__meta-item"><span>Garment category</span><strong>' + escapeHtml(result.category) + '</strong></div>' +
            '<div class="dd-art-checker__meta-item"><span>Code format</span><strong>' + escapeHtml(result.format) + '</strong></div>' +
          '</div>' +
        '</div>' +
        '<div class="dd-art-checker__breakdown">' +
          '<h3>How this code was read</h3>' +
          '<dl class="dd-art-checker__parts">' + parts + '</dl>' +
          '<p class="dd-art-checker__result-note">Decode based on documented label patterns and archive examples. Unknown internal fabric or treatment values are left unresolved deliberately.</p>' +
          warnings +
        '</div>' +
      '</article>'
    );
  }

  function buildSearchUrl(searchUrl, term, sectionOnly) {
    var separator = searchUrl.indexOf('?') === -1 ? '?' : '&';
    var url = searchUrl + separator + 'q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
    if (sectionOnly) url += '&section_id=main-search';
    return url;
  }

  function findProductItems(markup) {
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var candidates = Array.prototype.slice.call(parsed.querySelectorAll('#product-grid .grid__item'));
    var seen = {};

    return candidates.filter(function (item) {
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return false;
      var href = (link.getAttribute('href') || '').split('?')[0];
      if (!href || seen[href]) return false;
      seen[href] = true;
      return true;
    });
  }

  function setupChecker(root) {
    var form = root.querySelector('[data-dd-art-form]');
    var input = root.querySelector('[data-dd-art-input]');
    var message = root.querySelector('[data-dd-art-message]');
    var resultContainer = root.querySelector('[data-dd-art-result]');
    var archive = root.querySelector('[data-dd-art-archive]');
    var archiveCopy = root.querySelector('[data-dd-art-archive-copy]');
    var archiveStatus = root.querySelector('[data-dd-art-archive-status]');
    var archiveLinks = root.querySelectorAll('[data-dd-art-archive-link]');
    var products = root.querySelector('[data-dd-art-products]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var maxResults = Number(root.getAttribute('data-max-results')) || 8;
    var activeRequest = 0;

    function setMessage(text) {
      if (!text) {
        message.hidden = true;
        message.textContent = '';
        return;
      }
      message.textContent = text;
      message.hidden = false;
    }

    function updateUrl(code) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('art', code);
      window.history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
    }

    function showArchiveLoading() {
      archive.hidden = false;
      products.innerHTML = '';
      archiveStatus.innerHTML = '<span class="dd-art-checker__archive-loading">Checking current and sold catalogue records…</span>';
    }

    function showArchiveEmpty(term) {
      archiveCopy.textContent = 'No exact Dans Designer listing is indexed for this reference yet.';
      archiveStatus.innerHTML =
        '<p>This does not affect the decode. It only means this exact style has not yet appeared in the searchable catalogue.</p>' +
        '<a class="dd-art-checker__search-fallback" href="' + escapeHtml(buildSearchUrl(searchUrl, term, false)) + '">Search the full shop</a>';
    }

    function showArchiveError(term) {
      archiveCopy.textContent = 'The decoder worked, but the live catalogue lookup could not finish.';
      archiveStatus.innerHTML =
        '<p>You can still open the store search for the same reference.</p>' +
        '<a class="dd-art-checker__search-fallback" href="' + escapeHtml(buildSearchUrl(searchUrl, term, false)) + '">Search Dans Designer</a>';
    }

    function updateArchiveLinks(term, label) {
      Array.prototype.forEach.call(archiveLinks, function (link) {
        link.href = buildSearchUrl(searchUrl, term, false);
        if (label) link.textContent = label;
      });
    }

    function renderProducts(items, term) {
      var visible = items.slice(0, maxResults);
      products.innerHTML = '';

      visible.forEach(function (item, itemIndex) {
        var clone = document.importNode(item, true);
        clone.removeAttribute('data-cascade');
        clone.classList.remove('scroll-trigger', 'animate--slide-in');
        Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (element) {
          element.removeAttribute('id');
        });
        Array.prototype.forEach.call(clone.querySelectorAll('[aria-labelledby]'), function (element) {
          element.removeAttribute('aria-labelledby');
        });
        Array.prototype.forEach.call(clone.querySelectorAll('img'), function (image) {
          image.loading = itemIndex < 4 ? 'eager' : 'lazy';
          image.decoding = 'async';
          image.sizes = '(min-width: 990px) 267px, (min-width: 750px) calc((100vw - 120px) / 2), calc((100vw - 48px) / 2)';
        });
        products.appendChild(clone);
      });

      archiveStatus.textContent = '';
      archiveCopy.textContent = items.length === 1
        ? 'One matching Dans Designer listing found.'
        : items.length + ' matching Dans Designer listings found, including sold archive records.';
      updateArchiveLinks(
        term,
        items.length > visible.length ? 'View all ' + items.length + ' matches' : 'Open full search'
      );
    }

    function searchArchive(result) {
      var requestId = ++activeRequest;
      var terms = unique(result.searchTerms || [result.normalised]);
      var index = 0;

      showArchiveLoading();

      function next() {
        var term = terms[index++];
        if (!term) {
          if (requestId === activeRequest) showArchiveEmpty(terms[0] || result.normalised);
          return Promise.resolve();
        }

        updateArchiveLinks(term);

        return fetch(buildSearchUrl(searchUrl, term, true), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Catalogue request failed');
            return response.text();
          })
          .then(function (markup) {
            if (requestId !== activeRequest) return;
            var items = findProductItems(markup);
            if (items.length) {
              renderProducts(items, term);
              return;
            }
            return next();
          })
          .catch(function () {
            if (requestId === activeRequest) showArchiveError(terms[0] || result.normalised);
          });
      }

      next();
    }

    function decode(value, options) {
      var decoded = decodeArtNumber(value);
      setMessage('');

      if (!decoded.valid) {
        resultContainer.hidden = true;
        resultContainer.innerHTML = '';
        archive.hidden = true;
        setMessage(decoded.message);
        return;
      }

      input.value = decoded.displayCode;
      resultContainer.innerHTML = resultHtml(decoded);
      resultContainer.hidden = false;
      updateUrl(decoded.normalised);
      searchArchive(decoded);

      var copyButton = resultContainer.querySelector('[data-dd-art-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var url = window.location.href;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
              copyButton.textContent = 'Copied';
              window.setTimeout(function () { copyButton.textContent = 'Copy link'; }, 1600);
            });
          } else {
            copyButton.textContent = 'Link ready';
          }
        });
      }

      if (!options || !options.silentScroll) {
        window.requestAnimationFrame(function () {
          var header = document.querySelector('.dd-header-wrapper');
          var headerHeight = header ? header.getBoundingClientRect().height : 0;
          var offset = Math.ceil(headerHeight) + 16;
          var targetTop = window.pageYOffset + resultContainer.getBoundingClientRect().top - offset;
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        });
      }

      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'dd_art_check',
          art_brand: decoded.family,
          art_format: decoded.format,
          art_result: decoded.season
        });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      decode(input.value);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-dd-art-example]'), function (button) {
      button.addEventListener('click', function () {
        var example = button.getAttribute('data-dd-art-example');
        input.value = example;
        decode(example);
      });
    });

    var initial = new URL(window.location.href).searchParams.get('art');
    if (initial) {
      input.value = initial;
      decode(initial, { silentScroll: true });
    }
  }

  var api = {
    decodeArtNumber: decodeArtNumber,
    normaliseInput: normaliseInput,
    legacySeason: legacySeason,
    currentCpSeason: currentCpSeason,
    newStoneSeason: newStoneSeason
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.DDArtChecker = api;

  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-dd-art-checker]'), setupChecker);
    });
  }
})();
